import AwsLogo from "../../images/technology/icons/aws-logo.svg";
import VueLogo from "../../images/technology/icons/vuejs-logo.svg";
import RailsLogo from "../../images/technology/icons/rails-logo.svg";
import NextLogo from "../../images/technology/icons/next-logo.svg";
import ReactLogo from "../../images/technology/icons/react-logo.svg";
import ReduxLogo from "../../images/technology/icons/redux-logo.svg";
import NodeLogo from "../../images/technology/icons/node-js-logo.svg";
import StripeLogo from "../../images/technology/icons/stripe-logo.svg";
import JavaScriptLogo from "../../images/technology/icons/js-logo.svg";
import TypeScriptLogo from "../../images/technology/icons/ts-logo.svg";
import GatsbyLogo from "../../images/technology/icons/gatsby-logo.svg";
import AwsCdnLogo from "../../images/technology/icons/aws-cdn-logo.svg";
import GraphqlLogo from "../../images/technology/icons/graphql-logo.svg";
import ExpressLogo from "../../images/technology/icons/express-logo.svg";
import RedwoodLogo from "../../images/technology/icons/redwood-logo.svg";
import StencilLogo from "../../images/technology/icons/stenciljs-logo.svg";
import MongoDBLogo from "../../images/technology/icons/mongo-db-logo.svg";
import ReduxSagaLogo from "../../images/technology/icons/redux-saga-logo.svg";
import MaterialUILogo from "../../images/technology/icons/material-ui-logo.svg";
import WebComponentsLogo from "../../images/technology/icons/web-components-logo.svg";

export const TECHNOLOGY_ICON_HEIGHT = 74;

export const TECHNOLOGY_ICON_SRC = {
  AWS: AwsLogo,
  Vue: VueLogo,
  Next: NextLogo,
  Node: NodeLogo,
  React: ReactLogo,
  Redux: ReduxLogo,
  Stripe: StripeLogo,
  Gatsby: GatsbyLogo,
  GraphQL: GraphqlLogo,
  Express: ExpressLogo,
  MongoDB: MongoDBLogo,
  Redwood: RedwoodLogo,
  Stencil: StencilLogo,
  "AWS CDN": AwsCdnLogo,
  Typescript: TypeScriptLogo,
  Javascript: JavaScriptLogo,
  "Ruby on Rails": RailsLogo,
  "Redux Saga": ReduxSagaLogo,
  "Material UI": MaterialUILogo,
  "Web Components": WebComponentsLogo,
};
